import React from 'react';
import PropTypes from 'prop-types';

const LeftArrowWithShadow = ({ fill = 'var(--SECONDARY_DARK)' }) => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_7826_108390)">
      <circle cx="22" cy="19" r="12" fill="white" />
    </g>
    <path
      d="M22.9296 22.8326C23.1527 23.0558 23.5146 23.0558 23.7377 22.8326C23.9491 22.6212 23.9602 22.2854 23.7711 22.0609L23.7377 22.0245L20.7134 19L23.7377 15.9755C23.9491 15.7641 23.9602 15.4282 23.7711 15.2037L23.7377 15.1674C23.5263 14.956 23.1904 14.9448 22.9659 15.134L22.9296 15.1674L19.501 18.5959C19.2896 18.8074 19.2785 19.1432 19.4676 19.3677L19.501 19.4041L22.9296 22.8326Z"
      fill={fill}
    />
    <defs>
      <filter
        id="filter0_d_7826_108390"
        x="0"
        y="0"
        width="44"
        height="44"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.168627 0 0 0 0 0.176471 0 0 0 0 0.258824 0 0 0 0.14 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7826_108390"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7826_108390"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

LeftArrowWithShadow.propTypes = {
  fill: PropTypes.string,
};

export default LeftArrowWithShadow;
